import React, {useState} from 'react';
import {BaseContainer} from "../components/ui-base/base-container";
import {Box, Button, Grid} from "@material-ui/core";
import {AddBookForm} from "../components/author/add-book/add-book-form";
import styled from "styled-components";
import {Colors} from "../theme/colors";
import EditProfileForm from "../components/author/edit-profile/edit-profile-form";
import {useHistory, useLocation} from "react-router-dom";
import {useTranslation} from "react-i18next";

const FirstLoginPage = () => {
    const [activeStep, setActiveStep] = useState(1);
    const history = useHistory();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const publisherAlias = queryParams && ((queryParams.get('publisher')) as string || null);
    const { t } = useTranslation('author');

    return (
        <Box
            display={'flex'}
            flex={1}
            flexDirection={'column'}
        >
            {activeStep !== 2 && activeStep !== 4 && <Box flex={1} display={'flex'}>
                <BaseContainer>
                    {activeStep === 1 ?
                        <AddBookForm
                            firstLoginNextStep={() => setActiveStep(2)}
                            publisherAlias={publisherAlias}
                        />
                    : ''}

                    {activeStep === 3 ?
                        <EditProfileForm
                            actionAfterSave={() => setActiveStep(4)}
                        />
                        : ''}
                </BaseContainer>
            </Box> }

            {activeStep === 2 ?
                <StyledSuccessContainer>
                    <StyledSuccessP>{t('firstLogin.manuscriptSaved1')}</StyledSuccessP>
                    <StyledSuccessP>{t('firstLogin.manuscriptSaved2')}</StyledSuccessP>
                    <div>
                        <StyledSuccessButton type="button" variant="contained" onClick={() => {setActiveStep(3)}}>
                            {t('firstLogin.fillProfile')}
                        </StyledSuccessButton>
                        <StyledSuccessButton type="button" variant="contained" onClick={() => {history.push('/dashboard')}}>
                            {t('firstLogin.skip')}
                        </StyledSuccessButton>
                    </div>
                </StyledSuccessContainer>
            : ''}

            {activeStep === 4 ?
                <StyledSuccessContainer>
                    <StyledH6>{t('firstLogin.profileFill1')}</StyledH6>
                    <StyledSuccessP>{t('firstLogin.profileFill2')}</StyledSuccessP>
                    <StyledSuccessP>{t('firstLogin.profileFill3')}</StyledSuccessP>
                    <Grid>
                        <StyledSuccessButton type="button" variant="contained" onClick={() => {history.push('/dashboard')}}>
                            {t('firstLogin.profileFill4')}
                        </StyledSuccessButton>
                    </Grid>
                </StyledSuccessContainer>
            : ''}
        </Box>
    );
}

const StyledSuccessContainer = styled('div')`
  background-color: ${Colors.violet};
  max-width: 800px;
  padding: 2rem 6rem;
  margin: 0 auto;
`;

const StyledSuccessP = styled('p')`
  color: #fff;
  margin-bottom: 1rem;
  line-height: 1.5rem;
`;

const StyledSuccessButton = styled(Button)`
  color: #fff !important;
  background-color: transparent !important;
  border: 1px solid #fff !important;
  margin-right: 10px !important;
`;

const StyledH6 = styled('h6')`
  color: #fff;
  font-weight: bold;
  font-size: 1rem;
  margin-bottom: 1.5rem;
`;

export default FirstLoginPage;
